import { Pagination } from 'antd';
import moment from 'moment';
import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import CeoCommunicationsList from '@/src/ceoComminucations/CeoCommunicaitonsList';
import Container from '@/src/shared/components/Container';
import Head from '@/src/shared/components/Head';
import Heading from '@/src/shared/components/Heading';
import Hero from '@/src/shared/components/Hero';
import Layout from '@/src/shared/components/Layout';
import withMembershipAccessWrap, {
  mapStateToProps,
} from '@/src/shared/components/MembershipPageWrap';
import Section from '@/src/shared/components/Section';
import { ABOUT_ACCESS } from '@/src/shared/constants';
import { space } from '@/styles';
import request from '@/utils/axios';
import formatURL from '@/utils/formatURL';

const PAGE_SIZE = 20;

const CeoCommunications = () => {
  const router = useRouter();
  const [CommData, setCommData] = useState([]);

  useEffect(() => {
    const fetchPageData = async () => {
      const response = await request({
        url: `broadcast/viewonlinelist`,
        params: {
          broadcasttype: 2,
        },
      });
      const { data } = response;
      data.sort((a, b) => (moment(a.CompletionDate) < moment(b.CompletionDate) ? 1 : -1));
      setCommData(data);
    };
    fetchPageData();
  }, []);

  const [current, setCurrent] = useState(
    router.query.page && !Number.isNaN(router.query.page) ? Number(router.query.page) : 1
  );

  function handlePaginationChange(page) {
    setCurrent(page);
    const newURL = formatURL(router.asPath, { page });
    router.replace(newURL, newURL, { shallow: true });
  }

  function renderResults() {
    const paginatedResults = CommData.slice((current - 1) * PAGE_SIZE, current * PAGE_SIZE);
    const dataResults = {};
    for (let i = 0; i < paginatedResults.length; i += 1) {
      const results = paginatedResults[i];
      const resultDate = moment(results.CompletionDate).format('MMMM YYYY');
      if (resultDate in dataResults) {
        dataResults[resultDate].push(results);
      } else {
        dataResults[resultDate] = [results];
      }
    }

    return Object.entries(dataResults).map(([date, _results]) => {
      return (
        <>
          <Heading type={3} weight="bold" theme="primaryGray" css={[space.m.t20, space.m.b20]}>
            {date}
          </Heading>
          <CeoCommunicationsList data={_results} />
        </>
      );
    });
  }

  const pageTitle = 'CEO Communications';

  return (
    <Layout>
      <Head title={pageTitle} />
      <Hero title={pageTitle} />
      <Section bgColor="gray">
        <Container size="sm">
          <Pagination
            onChange={handlePaginationChange}
            total={CommData.length}
            pageSize={PAGE_SIZE}
            current={current}
          />
          {renderResults()}
        </Container>
      </Section>
    </Layout>
  );
};

export default connect(mapStateToProps)(
  withMembershipAccessWrap(CeoCommunications, ABOUT_ACCESS.CEO_COMMUNICATIONS, true)
);
